module.exports = __webpack_public_path__ + "static/media/editor-icon-italic-active.fad0a8e2.svg";